"use strict";

export const lcvReportsConstants = {
     LCV_REPORTS_GET_DEALERS_REQUEST: "LCV_REPORTS_GET_DEALERS_REQUEST",
     LCV_REPORTS_GET_DEALERS_COMPLETE: "LCV_REPORTS_GET_DEALERS_COMPLETE",

     LCV_REPORTS_GET_DEALERS_EXPORT_REQUEST: "LCV_REPORTS_GET_DEALERS_EXPORT_REQUEST",
     LCV_REPORTS_GET_DEALERS_EXPORT_COMPLETE: "LCV_REPORTS_GET_DEALERS_EXPORT_COMPLETE",
     LCV_REPORTS_CLEAR_DEALERS_EXPORT: "LCV_REPORTS_CLEAR_DEALERS_EXPORT",

     LCV_REPORTS_GET_GAMES_REQUEST: "LCV_REPORTS_GET_GAMES_REQUEST",
     LCV_REPORTS_GET_GAMES_COMPLETE: "LCV_REPORTS_GET_GAMES_COMPLETE",

     LCV_REPORTS_GET_GAMES_EXPORT_REQUEST: "LCV_REPORTS_GET_GAMES_EXPORT_REQUEST",
     LCV_REPORTS_GET_GAMES_EXPORT_COMPLETE: "LCV_REPORTS_GET_GAMES_EXPORT_COMPLETE",
     LCV_REPORTS_CLEAR_GAMES_EXPORT: "LCV_REPORTS_CLEAR_GAMES_EXPORT",

     LCV_REPORTS_GET_FILTER_OPTIONS_REQUEST: "LCV_REPORTS_GET_FILTER_OPTIONS_REQUEST",
     LCV_REPORTS_GET_FILTER_OPTIONS_COMPLETE: "LCV_REPORTS_GET_FILTER_OPTIONS_COMPLETE",
};
